import { PaymentMethod } from '@stripe/stripe-js';
import { HttpHandler } from '../../api/HttpHandler';
import { environment } from '../../enviroments';
import { IntlShape } from 'react-intl';

interface IAttachNewPaymentMethodToCustomerParams {
  paymentMethod: PaymentMethod | undefined;
  user_email: string;
  user_id: string;
  user_name: string;
  intl: IntlShape;
}

export const attachNewPaymentMethodToCustomer = async ({
  paymentMethod,
  user_email,
  user_id,
  user_name,
  intl,
}: IAttachNewPaymentMethodToCustomerParams) => {
  if (!paymentMethod) {
    throw new Error(
      intl.formatMessage({
        id: 'booking.error.stripe_not_loaded_yet',
        defaultMessage:
          'Сервіс для оплати ще не загрузився, спробуйте сплатити через 10 секунд, або перезагрузіть сторінку.',
      })
    );
  }

  try {
    const response = await HttpHandler({
      method: 'POST',
      url: `${environment.PAYMENTS_URL}/customer/attach-payment-method/${paymentMethod.id}`,
      data: { user_email, user_id, user_name },
    });

    return response;
  } catch (error: any) {
    throw new Error(error);
  }
};
